/* eslint-disable camelcase */
import {
    getProxiedServiceUrl
} from 'gw-portals-url-js';
import {
    JsonRPCService
} from 'gw-portals-transport-js';

export default class FNOLService {
    static submitClaim(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'),
            'submitClaim', [data], additionalHeaders);
    }

    static getFNOLDetails(policyNumber, data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'),
            'createClaim', [policyNumber, data], additionalHeaders);
    }

    static getFNOLDetails_EXT(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'),
            'createSasriaClaim', [data], additionalHeaders);
    }

    static getClaim(claimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'),
            'getClaim', [claimNumber], additionalHeaders);
    }

    static saveFNOLDetails(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'),
            'saveClaim', [data], additionalHeaders);
    }

    static searchPolicies(policySearchCriteria, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnolPolicy'), 'searchPolicies', [policySearchCriteria], additionalHeaders);
    }

    static getPolicySummaryRiskUnits(policyNumber, lossDate, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnolPolicy'), 'getPolicySummaryRiskUnits', [policyNumber, lossDate], additionalHeaders);
    }

    static searchInsured(insured, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnolInsured'), 'searchInsured', [insured], additionalHeaders);
    }

    static getSasriaClassCodes(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnolPolicy'), 'getSasriaClassCodes_EXT', [], additionalHeaders);
    }

    static getPolicyLimitForF4(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnolPolicy'), 'getSasriaPolicyLimitForF4_EXT', [], additionalHeaders);
    }

    static createInsured(insured, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnolInsured'), 'createInsured', [insured], additionalHeaders);
    }

    static submitClaim_EXT(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'),
            'submitClaim_EXT', [data], additionalHeaders);
    }

    static getVehicleDetailsFromPolicy_EXT(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'),
            'getVehicleDetailsFromPolicy_EXT', [data], additionalHeaders);
    }

    static populateRegistrationYearFromTU_EXT(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'),
            'populateRegistrationYearFromTU_EXT', [], additionalHeaders);
    }

    static populateMakeFromTU_EXT(year, mmcode, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'),
            'populateTUMake_EXT', [year, mmcode], additionalHeaders);
    }

    static populateTUModel_EXT(year, mmcode, make, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'),
            'populateTUModel_EXT', [make, mmcode, year], additionalHeaders);
    }

    static populateVariantFromTU_EXT(make, year, mmcode, model, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'),
            'populateTUVariant_EXT', [make, mmcode, year, model], additionalHeaders);
    }

    static retrieveMMCodeFromOtherSpecifications_EXT(make, variant, year, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'),
            'retrieveMMCodeFromOtherSpecifications_EXT', [make, variant, year], additionalHeaders);
    }

    static getYearForMMCode_EXT(mmmcode, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'),
            'getYearForMMCode_EXT', [mmmcode], additionalHeaders);
    }

    static getVehicleDetailsFromMMCodeYear(mmmcode, year, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'),
            'getVehicleDetailsFromMMCodeYear_EXT', [mmmcode, year], additionalHeaders);
    }

    static populateSariaBankNames_EXT(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'), 'populateBankNamesForInsured_EXT', [], additionalHeaders);
    }

    static populateSariaBranchCodeForBankName_EXT(selectedBankName, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'), 'populatebankcodeForBanks_EXT', [selectedBankName], additionalHeaders);
    }

    static creatingOneinsured_EXt(claimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'), 'craetingOneinsured_EXt', [claimNumber], additionalHeaders);
    }

    static saveBankDetails_EXT(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'),
            'saveBankData_EXT', [data], additionalHeaders);
    }

    static populateExistingAgentBank_EXT(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'), 'retrieveExistingBanks_EXT', [], additionalHeaders);
    }

    static retrieveExistingInsuredBanks_EXT(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'), 'retrieveExistingInsuredBanks_EXT', [data], additionalHeaders);
    }

    static checkIfDuplicateClaimExists_Ext(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'), 'checkIfDuplicateClaimExists', [data], additionalHeaders);
    }

    static validateInsuredData_Ext(insured, id, passport, regNo, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'), 'validateInsuredData_EXT', [insured, id, passport, regNo], additionalHeaders);
    }

    static fetchCatastropheList_EXT(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'),
            'fetchCatastrophe', [], additionalHeaders);
    }

    static validateCatastropheDetails_EXT(claim, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'),
            'validateCatastropheDetails', [claim], additionalHeaders);
    }
}
